import { fullOuterJoin } from "../../common/utilities/LinqExtensions";
import { IUIUserFavoriteModel } from "../../services/ui-personalization-data-service/Models";
import { UserFavoritesManagerFieldType } from "./UserFavoritesManagerFieldTypes";

export function mergeFavorites(
    models: Array<IUIUserFavoriteModel>,
    field: UserFavoritesManagerFieldType
): Array<IUIUserFavoriteModel> {

    return fullOuterJoin(
        field.favorites,
        models,
        o => o.id,
        i => i.id,
        (o, i) => {
            return {
                field: o,
                model: i
            };
        })
        .where(o => !!o.model && !!o.field)
        .select((o, index) => {
            return {
                ...o.model,
                description: o.field.description,
                isHomeUrl: o.field.isHomeUrl,
                order: index
            };
        })
        .toArray();
}

export function toUserFavoritesManagerField(models: Array<IUIUserFavoriteModel>): UserFavoritesManagerFieldType {
    return {
        favorites: models.map(model => {
            return {
                id: model.id,
                description: model.description,
                isHomeUrl: model.isHomeUrl,
                order: model.order,
                eLynxAppID: model.eLynxAppID
            };
        }).sort((a, b) => a.order - b.order)
    };
}